import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import VerificationPage from "./VerificationPage";
import VerificationSuccessPage from "./VerificationSuccessPage";

export function Verification() {
    return (
        <div className="d-flex flex-column flex-root">
            <div
                className="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
                id="kt_login"
            >
                <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
                {/* Contenedor separado para el logo */}
                <div style={{ textAlign: 'center', marginTop: '50px', width: '100%' }}>
                    <img 
                    src={toAbsoluteUrl("/media/logo/logo.png")}
                    style={{ maxWidth: '150px' }}
                    alt="Logo"
                    />
                </div>

                {/* Contenido restante de la página */}
                <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                    <Switch>
                    <ContentRoute path="/user-verification" component={VerificationPage} />
                    <ContentRoute path="/user-verification-success" component={VerificationSuccessPage} />
                    <Redirect to="/user-verification" />
                    </Switch>
                </div>
                </div>
            </div>
        </div>
    );
}